/**
 * Which sheet is open lives in the URL, so the back button closes it, a
 * reload keeps it, and a show can be linked. One sheet at a time: opening one
 * drops the others. `?show=` stays Upcoming's single-listing link, untouched.
 */
export type SheetKind = "show" | "edit" | "log" | "flyer" | "band" | "venue" | "year" | "person";

export const PARAM: Record<SheetKind, string> = {
  show: "s",
  edit: "edit",
  log: "log",
  flyer: "flyer",
  band: "band",
  venue: "venue",
  year: "review",
  person: "person",
};
const ORDER: SheetKind[] = ["edit", "log", "show", "flyer", "band", "venue", "year", "person"];

export interface OpenSheet {
  kind: SheetKind;
  value: string;
}

export function readSheet(sp: URLSearchParams): OpenSheet | null {
  for (const kind of ORDER) {
    const value = sp.get(PARAM[kind]);
    if (value) return { kind, value };
  }
  return null;
}

export function withSheet(sp: URLSearchParams, kind: SheetKind, value: string | number): URLSearchParams {
  const next = withoutSheet(sp);
  next.set(PARAM[kind], String(value));
  return next;
}

export function withoutSheet(sp: URLSearchParams): URLSearchParams {
  const next = new URLSearchParams(sp);
  for (const p of Object.values(PARAM)) next.delete(p);
  return next;
}

/** Log sheet values: "1" is blank, "u<id>" starts from an Upcoming listing. */
export const logValue = (upcomingId?: number) => (upcomingId ? `u${upcomingId}` : "1");
export const upcomingIdOf = (value: string) => (/^u\d+$/.test(value) ? Number(value.slice(1)) : null);
